import React, { useState } from 'react';

import { Grid, makeStyles } from '@material-ui/core';
import Footer from 'common/footer/footer';
import { IMG_LOGO, IMG_RESET_PASSWORD } from 'images';
import { useHistory } from 'react-router-dom';
import { CollectEmail } from './screenTypes/collectEmail';
import { VerifyAndSetPassword } from './screenTypes/verifyAndSetPassword';
import { Loader } from 'common';
import { SuccessModal } from './modal/successModal';
import { CodeExpiredModal } from './modal/codeExpiredModal';
import { CodeSentSnackbar } from './snackbar/codeSentSnackbar';

const useStyles = makeStyles({
  container: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerContainer: {
    alignSelf: 'baseline',
    padding: '14px 18px',
  },
  contentContainer: {
    alignSelf: 'center',
    zIndex: 10,
  },
  footerContainer: {
    alignSelf: 'flex-end',
    zIndex: 10,
  },
  logo: {
    cursor: 'pointer',
  },
  illustration: {
    position: 'absolute',
    bottom: '55px',
    maxWidth: '100vw',
    zIndex: 1,
  },
});

const ResetPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [screen, setScreen] = useState(0);
  const [resetId, setResetId] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showCodeExpiredModal, setShowCodeExpiredModal] = useState(false);
  const [showVerificationCodeSent, setShowVerificationCodeSent] = useState(
    false
  );

  const redirect = (to) => () => {
    history.push(to);
  };

  const resetPage = () => {
    setIsLoading(false);
    setScreen(0);
    setResetId('');
    setShowSuccessModal(false);
    setShowCodeExpiredModal(false);
  };

  return (
    <Grid container classes={{ root: classes.container }}>
      <Grid item xs={12} classes={{ root: classes.headerContainer }}>
        <img
          className={classes.logo}
          src={IMG_LOGO}
          alt="Senseloaf"
          onClick={redirect('/')}
        />
      </Grid>
      <Grid item xs={12} classes={{ root: classes.contentContainer }}>
        {screen === 0 ? (
          <CollectEmail
            setIsLoading={setIsLoading}
            setScreen={setScreen}
            setResetId={setResetId}
            setShowVerificationCodeSent={setShowVerificationCodeSent}
          />
        ) : (
          <VerifyAndSetPassword
            setIsLoading={setIsLoading}
            resetId={resetId}
            setShowSuccessModal={setShowSuccessModal}
            setShowCodeExpiredModal={setShowCodeExpiredModal}
          />
        )}
      </Grid>
      <Grid item xs={12} classes={{ root: classes.footerContainer }}>
        <Footer />
      </Grid>
      <img
        src={IMG_RESET_PASSWORD}
        alt="Reset Password Illustration"
        className={classes.illustration}
      />
      <SuccessModal isOpen={showSuccessModal} redirectToLogin={redirect('/')} />
      <CodeExpiredModal isOpen={showCodeExpiredModal} resetPage={resetPage} />
      <CodeSentSnackbar
        isOpen={showVerificationCodeSent}
        onClose={() => setShowVerificationCodeSent(false)}
      />
      {isLoading && <Loader position="absolute" />}
    </Grid>
  );
};

export default ResetPassword;
